import React from "react";
import { TableSection } from "../TableSection/TableSection";
import { RowOptions } from "../TableSection/TableSection";
import LecturesLogo from "../../Photos/lectures-text.svg"
import { SectionProps } from "../../App";

interface LectureProps {}

/**
 * Returns whether or not <assignment> should appear as released yet
 * @param assignment the assignment that should or should not be released
 * @return true if "now" is after/on the release date, false otherwise
 */
function shouldRelease(assignment: RowOptions): boolean {
    if (assignment.autoReleaseDate === undefined) {
      return true; // If no defined release date, treat it as released if it has an href
    }
  
    const now = new Date();
  
    // Convert now into EST, if it isn't already
    const nowEST = new Date(
      now.toLocaleString("en-US", {
        timeZone: "America/New_York",
      })
    );
  
    return nowEST > new Date(assignment.autoReleaseDate);
}

export class Lectures extends React.Component<SectionProps> {
  myHeader: string[] = [
    "Date",
    "Lecture",
    "PDF",
    "Printable PDF",
    "Slides",
    "Recordings",
    "Skit",
    "Code",
  ];
  myRows: RowOptions[] = [
    {
      cellNames: [
        "9/4",
        "Welcome to CS0150+What is Programming?",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "Skit",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L1%20(Sep%204)?preview=71475676",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L1%20(Sep%204)?preview=71475675",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1FDUsX3oO0SYGY3xHzHbbvVi7S6nJ_v0K/edit?usp=sharing&ouid=105916290897073440539&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=f337702a-5508-4870-9882-b34600e1bb28",
        ],
        ["Skit", "https://youtu.be/Srmeq76bcmI"],
      ]),
      autoReleaseDate: "Sep 4, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "9/9",
        "Calling and Defining Methods",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L2%20(Sep%209)?preview=71486895",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L2%20(Sep%209)?preview=71486896",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1fMQP9EqIwtEdV5ZG-MFOpqlyXcXNy6ww/edit?usp=drive_link&ouid=105916290897073440539&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=51bb4e3a-7d8d-4410-b5c4-b34600e1bc04",
        ],
      ]),
      autoReleaseDate: "Sep 9, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "9/11",
        "Introduction to Parameters and Math",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L3%20(Sep%2011)?preview=71505300",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L3%20(Sep%2011)?preview=71505309",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1tH7jOv1P7e07-Epop4LGsTOeXOUmaJki/edit",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=adf992cc-4e0e-4e1a-bd32-b34600e1bc2a",
        ],
      ]),
      autoReleaseDate: "Sep 11, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "9/16",
        "Working with Objects I",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L4%20(Sep%2016)?preview=71529563",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L4%20(Sep%2016)?preview=71529564",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/132HPf4twUxc2eCkHD12JkN5VnBpzulY_/edit?usp=drive_web&ouid=106079776746884357575&rtpof=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=f2c13ddf-12ef-4440-a9b6-b34600e1bc67",
        ],
      ]),
      autoReleaseDate: "Sep 16, 2025 13:30:00 EDT",
    },
    {
      cellNames: [
        "9/18",
        "Working with Objects II",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L5%20(Sep%2018)?preview=71538760",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L5%20(Sep%2018)?preview=71538759",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1nj-tu0Vy2VEy6OfxoCRX6TBNqz_IxnGz/edit?usp=sharing&ouid=105916290897073440539&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=5092ad76-ac5d-4d20-900f-b34600e1bca0",
        ],
      ]),
      autoReleaseDate: "Sep 18, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "9/23",
        "Interfaces and Polymorphism",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L6%20(Sep%2023)?preview=71551144",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L6%20(Sep%2023)?preview=71551145",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1foV5I4LeDO5Ji3ljgNG_lLa2cT2hVXUA/edit?slide=id.p146#slide=id.p146",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=3cf6814c-2d85-46f7-b406-b34600e1bcc0",
        ],
      ]),
      autoReleaseDate: "Sep 22, 2025 19:30:00 EDT",
    },
    {
      cellNames: [
        "9/25",
        "Inheritance and Polymorphism",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L7%20(Sep%2025)?preview=71558261",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L7%20(Sep%2025)?preview=71558260",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1biZ70DI_VQRQdQXLctc2UiKkwVzj7jkJ/edit?usp=sharing&ouid=104968105262251965217&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=76473475-ff53-4a0d-9cfa-b34600e1bce4",
        ],
      ]),
      autoReleaseDate: "Sep 24, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "9/30",
        "Arithmetic and Making Decisions",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "Skit",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L8%20(Sep%2030)?preview=71571226",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L8%20(Sep%2030)?preview=71571225",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/10MR_TH4VfH7QKWvBPwZXL-Xpm5esowNl/edit?slide=id.p70#slide=id.p70",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=bf5cfa34-5b74-445f-ba78-b34600e1bd0f",
        ],
        ["Skit", ""],
      ]),
      autoReleaseDate: "Sep 29, 2025 21:00:00 EDT",
    },
    {
      cellNames: [
        "10/2",
        "Graphics I",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "Code",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L9%20(Oct%202)?preview=71580339",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L9%20(Oct%202)?preview=71580338",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1iUgRfhQHlfgzSj3_ySajlhIu45bJ6FQT/edit?usp=sharing&ouid=104968105262251965217&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=6de54328-4b70-4426-8323-b34600e1bd31",
        ],
        ["Code", "https://github.com/brown-cs15-2025/colorChanger"],
      ]),
      autoReleaseDate: "Oct 1, 2025 3:00:00 EDT",
    },
    {
      cellNames: [
        "10/7",
        "Graphics II",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "Code",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L10%20(Oct%207)?preview=71592375",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L10%20(Oct%207)?preview=71592371",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1wZG6oTpLeFBRg11UglaaEC5_qOdz3m5z/edit?slide=id.p6#slide=id.p6",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=3b70b71e-d2ba-4f6d-87e8-b34600e1bd53",
        ],
        ["Code", "https://github.com/brown-cs15-2025/clock"],
      ]),
      autoReleaseDate: "Oct 6, 2025 20:30:00 EDT",
    },
    {
      cellNames: [
        "10/9",
        "Graphics III",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "Code",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L11%20(Oct%208)?preview=71601255",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L11%20(Oct%208)?preview=71601256",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1M5RGqC13r6uNnRj7ehv2CRlfq-kucGKr/edit?usp=sharing&ouid=104968105262251965217&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=cc526792-223a-4ec3-8869-b34600e1bd83",
        ],
        ["Code", "https://github.com/brown-cs15-2025/alienMover"],
      ]),
      autoReleaseDate: "Oct 8, 2025 12:28:00 EDT",
    },
    {
      cellNames: [
        "10/14",
        "Arrays & Loops I",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L12%20(Oct%2013)?preview=71610414",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L12%20(Oct%2013)?preview=71610413",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1pm6FagBmbCQWXzV0geOm79pGxguKtlBR/edit?slide=id.p16#slide=id.p16",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=7cbb5e09-4ad1-406f-bf92-b34600e1bda4",
        ],
      ]),
      autoReleaseDate: "Oct 13, 2025 20:28:00 EDT",
    },
    {
      cellNames: [
        "10/16",
        "Arrays & Loops II",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L13%20(Oct%2016)?preview=71617133",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L13%20(Oct%2016)?preview=71617132",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1VKsXUL4H7imkvN-81oxcxWxsbVCrtaon/edit?usp=sharing&ouid=104968105262251965217&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=34cbc62b-8c8d-442d-9f8c-b34600e1bdc7",
        ],
      ]),
      autoReleaseDate: "Oct 15, 2025 3:10:00 EDT",
    },
    {
      cellNames: [
        "10/21",
        "Design Patterns and Principles I",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "Code",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L14%20(Oct%2021)?preview=71629341",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L14%20(Oct%2021)?preview=71629340",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1Y3bRQBViJt_1iUYhxlQ1U2Q_jAGc8Jwp/edit?slide=id.p1#slide=id.p1",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=382b532c-034d-485b-8ba0-b34600e1bde3",
        ],
        ["Code", "https://github.com/brown-cs15-2025/snake"],
      ]),
      autoReleaseDate: "Oct 20, 2025 20:28:00 EDT",
    },
    {
      cellNames: [
        "10/23",
        "Design Patterns and Principles II",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L15%20(Oct%2023)?preview=71639219",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L15%20(Oct%2023)?preview=71639220",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/13eWzJwX0ZFrrJtIDm9HV5tZU3vlsat5F/edit?usp=sharing&ouid=104968105262251965217&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=69d07f70-2744-43b5-89f8-b34600e1be09",
        ],
      ]),
      autoReleaseDate: "Oct 22, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "10/28",
        "Recursion",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L16%20(Oct%2028)?preview=71649376",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L16%20(Oct%2028)?preview=71649377",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1IcsYBbI7bi_OK8JcZ-XidNJjMPM33jfK/edit?slide=id.p1#slide=id.p1",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=9d05a799-8ccb-4cff-b0d5-b34600e1be2e",
        ],
      ]),
      autoReleaseDate: "Oct 27, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "10/30",
        "Big O and Sorting",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "Skit",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L17%20(Oct%2030)?preview=71657404",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L17%20(Oct%2030)?preview=71657403",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/15XLs_rZcz-LGkTEl_vuW_RX527FYPgFN/edit?usp=sharing&ouid=104968105262251965217&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=862b385e-bc8a-4790-a7fa-b34600e1be5d",
        ],
        ["Skit", ""],
      ]),
      autoReleaseDate: "Oct 29, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "11/4",
        "Data Structures I - LinkedLists",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L18%20(Nov%204)?preview=71667699",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L18%20(Nov%204)?preview=71667697",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1EGdiqi7dQxVJLexM3A72VQvC6wlB8YBB/edit?usp=sharing&ouid=104968105262251965217&rtpof=true&sd=true",
        ],
        [
          "Recording",
          "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=c3db92fd-6cdf-4025-9daa-b34600e1be8d",
        ],
        ["Skit", ""],
      ]),
      autoReleaseDate: "Nov 3, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "11/6",
        "Data Structures II - Stacks, Queues, Trees",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L19%20(Nov%205)?preview=71673905",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L19%20(Nov%205)?preview=71673906",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1eLC-xFnf1rErsr3YDU1Gop4rJJQa6rTB/edit?usp=sharing&ouid=104968105262251965217&rtpof=true&sd=true",
        ],
        ["Recording", "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=14420444-9833-4f04-af4b-b34600e1bea9"],
      ]),
      autoReleaseDate: "Nov 5, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "11/11",
        "Data Structures III - Sets, Maps, Hashing",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        [
          "PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L20%20(Nov%2010)?preview=71687973",
        ],
        [
          "Printable PDF",
          "https://canvas.brown.edu/courses/1099812/files/folder/Lectures/L20%20(Nov%2010)?preview=71687975",
        ],
        [
          "Slides",
          "https://docs.google.com/presentation/d/1ArAxzoQkY15ba8bBTcASUv1Vwe8-0E76/edit",
        ],
        ["Recording", "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=2f313f90-69ef-43bb-8785-b34600e1bec6"],
      ]),
      autoReleaseDate: "Nov 10, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "11/13",
        "Final Project Introduction",
        "-",
        "-",
        "-",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([["Recording", ""]]),
      autoReleaseDate: "Nov 13, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "11/18",
        "History of Computers, Languages, and Architecture",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        ["PDF", ""],
        ["Printable PDF", ""],
        ["Slides", ""],
        ["Recording", ""],
      ]),
      autoReleaseDate: "Nov 18, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "11/20",
        "Computer Graphics",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        ["PDF", ""],
        ["Printable PDF", ""],
        ["Slides", ""],
        ["Recording", ""],
      ]),
      autoReleaseDate: "Nov 20, 2025 14:28:00 EDT",
    },
    {
      cellNames: [
        "12/02",
        "Head TA Lectures",
        "PDF",
        "Printable PDF",
        "Slides",
        "Recording",
        "-",
        "-",
      ],
      cellNametoLinks: new Map<string, string>([
        ["PDF", ""],
        ["Printable PDF", ""],
        ["Slides", ""],
        ["Recording", ""],
      ]),
      autoReleaseDate: "Dec 2, 2025 14:28:00 EDT",
    },
  ];
  render() {
    // Modify the cellNametoLinks map based on the release status
    const modifiedRows: RowOptions[] = this.myRows.map((row) => {
      if (!shouldRelease(row)) {
        const updatedLinks = new Map<string, string>();

        // Iterate over the original links and replace or remove them if necessary
        row.cellNametoLinks.forEach((value, key) => {
          updatedLinks.set(key, "");
        });

        return {
          ...row,
          cellNametoLinks: updatedLinks,
          backgroundColor: "#FCD002aF",
        };
      }
      return row;
    });
    return (
      <section
        id="lectures"
        className={`anchor lectures ${this.props.static ? "static" : ""}`}
      >
        <center>
          <img
            className="lectures-logo logo"
            src={LecturesLogo}
            alt="lectures text"
            style={{ justifySelf: "center" }}
          />
        </center>
        <TableSection header={this.myHeader} rows={modifiedRows} />
      </section>
    );
  }
}
